"use strict";
exports.__esModule = true;
exports.SvgSymbolFaceHappy = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgSymbolFaceHappy = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20", fill: "currentColor" }, props),
    react_1["default"].createElement("circle", { cx: 10, cy: 10, r: 8.5 }),
    react_1["default"].createElement("path", { fill: "#000001", d: "M9.16 7.5c0 .46-.37.83-.83.83-.46 0-.83-.37-.83-.83 0-.46.37-.83.83-.83.46 0 .83.37.83.83zm3.34 0c0 .46-.37.83-.83.83-.46 0-.84-.37-.84-.83 0-.46.38-.83.84-.83.46 0 .83.37.83.83zm2.15 3.87c-.28 1.11-.91 2.05-1.67 2.64-.76.59-1.76.95-2.7 1-.94.05-1.97-.19-2.8-.7-.82-.5-1.54-1.36-1.95-2.44l-.17-.45.94-.34.17.45c.31.92.84 1.51 1.54 1.93.68.43 1.41.59 2.21.55.8-.04 1.51-.29 2.15-.79.64-.5 1.1-1.14 1.31-2.09l.97.24z" }))); };
//# sourceMappingURL=SymbolFaceHappy.js.map